import { notifications } from '@debbie/cortex/dist/index.js';
import React from 'react';
import CTC from 'react-copy-to-clipboard';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Copy from './Icons/Copy.js';
const CopyToClipboard = (props) => {
    const lang = useSelector((s) => s.lang);
    const text = props.text || (typeof props.children === 'string' && props.children) || '';
    return (React.createElement(StyledCopyToClipboard, { title: text, onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
        }, style: props.style },
        React.createElement(CTC, { onCopy: () => {
                notifications.notification({
                    title: lang.misc.copiedToClipboard,
                    subtitle: text,
                });
                props.onCopy && props.onCopy();
            }, text: text },
            React.createElement("span", null,
                props.children,
                " ",
                !props.hideIcon && React.createElement(Copy, { style: props.iconStyle })))));
};
export default CopyToClipboard;
const StyledCopyToClipboard = styled.div `
  cursor: pointer;
  display: inline-block;

  &:active {
    opacity: 0.5;
  }
`;
//# sourceMappingURL=CopyToClipboard.js.map